import { Button, type IconType } from "@memorang/ui";
import type { StyleProp, ViewStyle } from "react-native";

type ModuleActionButtonProps = {
	cta: string;
	icon: IconType;
	mode: "contained" | "outlined" | "text" | "contained-tonal";
	onPress: () => void;
	disabled?: boolean;
	loading?: boolean;
	compact?: boolean;
	style?: StyleProp<ViewStyle>;
};

export const ModuleActionButton = ({
	cta,
	icon,
	mode,
	onPress,
	disabled,
	loading,
	compact,
	style,
}: ModuleActionButtonProps) => (
	<Button
		mode={mode}
		icon={icon}
		onPress={onPress}
		disabled={disabled}
		loading={loading}
		compact={compact}
		style={[{ borderRadius: 999 }, style]}
	>
		{cta}
	</Button>
);
